<script setup lang="ts">
import { useClipboard } from "@vueuse/core"
import { widget as supportWidget } from "@/composables/support"

defineProps<{
  referralCode: string
}>()

const { copy, copied } = useClipboard()
</script>

<template>
  <div class="bg-gray-50 flex flex-col items-center py-4 px-2 rounded-xy">
    <div class="space-y-2.5 text-center">
      <div class="font-display font-extrabold text-xl leading-5 text-gray-700">
        Give a
        <span class="text-xy-blue">free</span> month,<br />
        get a <span class="text-xy-blue">free</span> month.
      </div>
      <div class="relative">
        <button class="xy-btn-secondary-sm" @click="copy(referralCode)">
          <span v-if="copied == true">Copied!</span>
          <span v-else>Copy Referral Code</span>
        </button>
      </div>
      <div class="space-y-1.5">
        <div class="text-sm leading-tight font-medium text-gray-700">
          Share membership with your XYPN referral code.
        </div>
        <div>
          <a
            href="https://help.xyplanningnetwork.com/article/223-referral-program"
            class="xy-btn-neutral-sm"
            @click.prevent="
              supportWidget.openArticle('640233c10b394c459d8a79f5')
            "
            >Learn More</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
